import { Card } from 'react-bootstrap';
import { FaStore } from 'react-icons/fa';
import EstadoCaja from './EstadoCaja';
import EstadosConexion from './EstadosConexion';

function EstadoLocal(props) {
  const local = props.local;
  const local_name = local.name || 'Sin local asignado';

  const counts = local.cajas.reduce(
    (acc, caja) => {
      if (caja.estado === EstadosConexion.Conectado) acc.ok += 1;
      else if (caja.estado === EstadosConexion.Alerta) acc.warn += 1;
      else acc.down += 1;
      return acc;
    },
    { ok: 0, warn: 0, down: 0 },
  );

  return (
    <Card className="local-card">
      <Card.Header className="local-header">
        <div className="local-header-main">
          <FaStore className="local-icon" />
          <span className="local-name">{local_name}</span>
          <span className="local-count">{local.cajas.length} caja{local.cajas.length !== 1 ? 's' : ''}</span>
        </div>
        <div className="local-pills">
          {counts.ok > 0 && <span className="pill pill-success">{counts.ok} OK</span>}
          {counts.warn > 0 && <span className="pill pill-warning">{counts.warn} alerta</span>}
          {counts.down > 0 && <span className="pill pill-danger">{counts.down} sin conexión</span>}
        </div>
      </Card.Header>
      <Card.Body className="p-0">
        <div className="table-responsive">
          <table className="cajas-table">
            <thead>
              <tr>
                <th>Caja</th>
                <th>Conexión</th>
                <th>Folios (disponibles / requeridos)</th>
                <th className="text-end">Último folio</th>
                <th className="text-center">Estado</th>
              </tr>
            </thead>
            <tbody>
              {local.cajas.map((caja) => (
                <EstadoCaja key={caja.device_id || caja.device_name} caja={caja} />
              ))}
            </tbody>
          </table>
        </div>
      </Card.Body>
    </Card>
  );
}

export default EstadoLocal;
